import React from 'react';
import { Box, Typography, Link, useTheme } from '@mui/material';
import { GlobalStyles } from '@mui/system';

const Copyright = ({clinicData}) => {
  console.warn('footer received: ', clinicData);
  const theme = useTheme();
  return (
    <>
      <GlobalStyles
        styles={{
          '@page': {
            size: 'A4 portrait',
            margin: '0mm',
            marginTop: '10mm',
            marginBottom: '10mm'
          },
          '.printPageBreak': {
            pageBreakAfter: 'always'
          },
          '@media print': {
            '::-webkit-scrollbar': {
              display: 'none',
            },
            body: {
              paddingBottom: theme.spacing(2), // Adjust this value to match the footer's height
            },
            '#handout-content': {
              position: 'relative',
              zIndex: 0
            },
            '.MuiBox-root': {
              position: 'relative',
              zIndex: 0,
              pageBreakInside: 'auto',
            },
            '.MuiListItem-padding': {
              pageBreakInside: 'avoid',
            },
            'section.title':  {
              marginBottom: '0px!important',
              marginTop: '0px!important'
            },
            '.callout': {
              marginBottom: '16px!important',
              pageBreakInside: 'avoid',
            }
          },
        }}
      />
      <Box
        component="footer"
        sx={{
          pt: 1,
          textAlign: 'left',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          '@media print': {
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100%',
            bgcolor: 'background.paper',
            zIndex: 0,
            overflow: 'visible',
            py: 0,
            display: 'none'
          },
        }}
      >
        <Typography variant="caption" sx={{ lineHeight: '1.5', fontSize: 16, '@media print': {fontSize: '6pt', marginBottom: '-9px'}}}>
          © Copyright Cetra Health. {' '}
          <Box sx={{'@media (min-width: 600px)': {display: 'inline-block'}}}>
            All rights reserved.
          </Box>
          <br />
          <Link 
            href={process.env.REACT_APP_CETRA_CLINIC_TYPE === 'vet' ? 'https://www.cetravets.com' : 'https://www.cetrahealth.com'}
            color="inherit" 
            underline="always"
            sx={{
              '@media print': {
                textDecoration: 'none',
                lineHeight: '1',
                display: 'block',
                marginTop: '-3px',
              },
            }}
            target="_blank" 
            rel="noopener"
          >
             {process.env.REACT_APP_CETRA_CLINIC_TYPE === 'vet' ? 'www.cetravets.com' : 'www.cetrahealth.com'}
          </Link>
        </Typography>
        {clinicData && clinicData.accountType === 'Clinic' && clinicData.showLogo && (
          clinicData.url ? (
            <img 
              src={clinicData.url} 
              style={{
                position: 'absolute',
                right: 10,
                bottom: 2,
                height: 75,
                marginTop: 0
              }} 
              alt="Clinic Logo" 
              cache={false} 
            />
          ) : (
            <Box sx={{position: 'absolute', right: 10, bottom: 2, fontSize: 16}}>
              {clinicData.clinicName}
            </Box>
          )
        )} 
        {clinicData && clinicData.accountType === 'Professional' && clinicData.clinicName &&  (
          <Box>{clinicData.clinicName}</Box>
        )} 
      </Box>
    </>
  );
};

export default Copyright;
